// @ts-nocheck
// Smooth FAQ accordion using the Web Animations API.
// Animates the <details> element's height directly so the transition is
// hardware-accelerated and not subject to grid-template-rows layout cost.
//
// Standard pattern from web.dev/animating-details/.
(() => {
  class FaqAccordion {
    constructor(detailsEl) {
      this.el = detailsEl;
      this.summary = detailsEl.querySelector('summary');
      this.content = detailsEl.querySelector('.plan-filter__faq-body');
      if (!this.summary || !this.content) return;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;
      if (this.animation) this.animation.cancel();
      this.animation = this.el.animate(
        { height: [startHeight, endHeight] },
        { duration: 420, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => { this.isClosing = false; };
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
      if (this.animation) this.animation.cancel();
      this.animation = this.el.animate(
        { height: [startHeight, endHeight] },
        { duration: 420, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => { this.isExpanding = false; };
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = '';
      this.el.style.overflow = '';
    }
  }

  const init = () => {
    document.querySelectorAll('.plan-filter__faq-item').forEach((el) => {
      if (el.dataset.smoothInit) return;
      el.dataset.smoothInit = '1';
      new FaqAccordion(el);
    });

    // Mirror the existing SIM-type error's visibility onto a warning that
    // lives next to the Add to cart button (so the user sees feedback in
    // the same place they were trying to click). On mobile this warning
    // is styled as a fixed overlay toast and auto-hides after 3 seconds.
    const simError = document.querySelector('.plan-filter__sim-type-error');
    const cartWarning = document.querySelector('.plan-filter__cart-warning');
    if (simError && cartWarning && !cartWarning.dataset.mirrorInit) {
      cartWarning.dataset.mirrorInit = '1';
      const isMobileViewport = () => window.matchMedia('(max-width: 749px)').matches;
      const sync = () => {
        const visible = simError.classList.contains('is-visible');
        cartWarning.classList.toggle('is-visible', visible);
        if (visible && isMobileViewport()) {
          clearTimeout(cartWarning._toastTimer);
          cartWarning._toastTimer = setTimeout(() => {
            cartWarning.classList.remove('is-visible');
            simError.classList.remove('is-visible');
          }, 3000);
        }
      };
      new MutationObserver(sync).observe(simError, { attributes: true, attributeFilter: ['class'] });
      sync();
    }

    // MOBILE only: move the "Select your SIM type" section into the pricing
    // card. Desktop keeps the SIM picker as its own section above the card.
    // Responsive: re-runs on viewport changes so a resize between desktop
    // and mobile updates the DOM placement correctly.
    const simTypeWrapper = document.querySelector('.plan-filter__details-title')?.closest('.plan-filter__step-wrapper');
    const pricingCard = document.querySelector('.plan-filter__product-footer');
    if (simTypeWrapper && pricingCard) {
      // Remember the original parent + next-sibling so we can restore on desktop
      if (!simTypeWrapper.dataset.origParent) {
        simTypeWrapper.dataset.origParent = '1';
        simTypeWrapper._origParent = simTypeWrapper.parentElement;
        simTypeWrapper._origNextSibling = simTypeWrapper.nextElementSibling;
      }
      const simMQ = window.matchMedia('(max-width: 749px)');
      const applySimPlacement = () => {
        if (simMQ.matches) {
          if (simTypeWrapper.parentElement !== pricingCard) {
            pricingCard.insertBefore(simTypeWrapper, pricingCard.firstChild);
          }
        } else {
          if (simTypeWrapper.parentElement !== simTypeWrapper._origParent && simTypeWrapper._origParent) {
            simTypeWrapper._origParent.insertBefore(simTypeWrapper, simTypeWrapper._origNextSibling);
          }
        }
      };
      simMQ.addEventListener('change', applySimPlacement);
      applySimPlacement();
    }

    // Inject a divider element before the Add to cart component. It's
    // styled only on mobile (CSS scoped to @media max-width: 749px), so it
    // remains invisible on desktop but available on mobile regardless of
    // initial viewport.
    const ctaComponent = document.querySelector('.plan-filter__product-footer add-to-cart-component');
    if (ctaComponent && !document.querySelector('.plan-filter__product-footer .cta-divider')) {
      const divider = document.createElement('div');
      divider.className = 'cta-divider';
      ctaComponent.parentElement.insertBefore(divider, ctaComponent);
    }

    // Lay out the price wrapper differently on mobile vs desktop:
    //  - On mobile, move retail-note + save-badge into price-wrapper.
    //  - On desktop, restore them to their original parents.
    // Responsive: re-runs on viewport changes.
    const priceWrapper = document.querySelector('.plan-filter__product-footer .plan-filter__price-wrapper');
    const retailNote = document.querySelector('.plan-filter__product-footer .plan-filter__price-note');
    const saveBadge = document.querySelector('.plan-filter__product-footer .plan-filter__discount-badge');
    if (priceWrapper) {
      // Capture originals once
      if (retailNote && !retailNote._origParent) {
        retailNote._origParent = retailNote.parentElement;
        retailNote._origNextSibling = retailNote.nextElementSibling;
      }
      if (saveBadge && !saveBadge._origParent) {
        saveBadge._origParent = saveBadge.parentElement;
        saveBadge._origNextSibling = saveBadge.nextElementSibling;
      }
      const priceMQ = window.matchMedia('(max-width: 749px)');
      const applyPricePlacement = () => {
        let group = priceWrapper.querySelector('.price-extras-group');
        if (priceMQ.matches) {
          if (retailNote && retailNote.parentElement !== priceWrapper) {
            priceWrapper.insertBefore(retailNote, priceWrapper.firstChild);
          }
          if (saveBadge) {
            if (!group) {
              group = document.createElement('div');
              group.className = 'price-extras-group';
              priceWrapper.appendChild(group);
            }
            if (saveBadge.parentElement !== group) group.appendChild(saveBadge);
          }
        } else {
          // Restore originals on desktop
          if (retailNote && retailNote._origParent && retailNote.parentElement !== retailNote._origParent) {
            retailNote._origParent.insertBefore(retailNote, retailNote._origNextSibling);
          }
          if (saveBadge && saveBadge._origParent && saveBadge.parentElement !== saveBadge._origParent) {
            saveBadge._origParent.insertBefore(saveBadge, saveBadge._origNextSibling);
          }
          if (group) group.remove();
        }
      };
      priceMQ.addEventListener('change', applyPricePlacement);
      applyPricePlacement();
    }

    // MOBILE only: move the "Check eSIM Compatibility" trigger under the
    // product card. Desktop keeps it inside the pricing card's top row.
    // Responsive: re-runs on viewport changes.
    const compatChecker = document.querySelector('compatibility-checker');
    const productCardWrap = document.querySelector('.pf-card-v2-wrap');
    if (compatChecker && productCardWrap) {
      if (!compatChecker.dataset.origParent) {
        compatChecker.dataset.origParent = '1';
        compatChecker._origParent = compatChecker.parentElement;
        compatChecker._origNextSibling = compatChecker.nextElementSibling;
      }
      const compatMQ = window.matchMedia('(max-width: 749px)');
      const applyCompatPlacement = () => {
        if (compatMQ.matches) {
          if (compatChecker.previousElementSibling !== productCardWrap) {
            productCardWrap.parentElement.insertBefore(compatChecker, productCardWrap.nextSibling);
          }
        } else {
          if (compatChecker.parentElement !== compatChecker._origParent && compatChecker._origParent) {
            compatChecker._origParent.insertBefore(compatChecker, compatChecker._origNextSibling);
          }
        }
      };
      compatMQ.addEventListener('change', applyCompatPlacement);
      applyCompatPlacement();
    }

    // Portal the compatibility-checker modal to <body> so `position: fixed`
    // and the dark backdrop work as expected. Its column ancestor has
    // `contain: layout` (added to stop FAQ expansion from resizing siblings),
    // which creates a containing block trap for fixed positioning.
    const compatModal = document.querySelector('.compatibility-checker-modal');
    if (compatModal && compatModal.parentElement !== document.body) {
      document.body.appendChild(compatModal);
    }

    // Defensive: show the .max-message whenever the user clicks "+" on the
    // quantity selector while already at the max. The existing logic in
    // plan-filter-product-card.liquid doesn't always fire when the increment
    // is blocked by the input's max attribute.
    document.querySelectorAll('quantity-selector-component[data-plan-quantity-selector]').forEach((qty) => {
      if (qty.dataset.maxClickInit) return;
      qty.dataset.maxClickInit = '1';
      const plusBtn = qty.querySelector('[ref="plusButton"]');
      const input = qty.querySelector('input[ref="quantityInput"]');
      const block = qty.closest('.plan-filter_quantity-block');
      const maxMessage = block?.querySelector('.max-message');
      if (!plusBtn || !input || !maxMessage) return;

      plusBtn.addEventListener('click', () => {
        const current = parseInt(input.value, 10);
        const maxAttr = parseInt(input.max || '', 10);
        const maxData = parseInt(input.dataset.max || '', 10);
        const max = Number.isFinite(maxData) ? maxData : maxAttr;
        if (!Number.isFinite(max) || !Number.isFinite(current)) return;
        if (current >= max) {
          maxMessage.classList.add('is-visible');
          clearTimeout(maxMessage._hideTimer);
          maxMessage._hideTimer = setTimeout(() => {
            maxMessage.classList.remove('is-visible');
          }, 4000);
        }
      }, true);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
